An opaque cursor to the later bounding webhook subscription replay.

Resulting subscription replays will _precede_ this cursor.
